import { connect } from "react-redux";
import PropTypes from "prop-types";
import BaggageInfo from "./BaggageInfo";
import { getSelectedBaggageList } from "app/pages/Booking/bookingSelectors";

const BaggageInfoContainer = ({ baggageList, ...props }) => {
	if (baggageList === null) {
		return null;
	}

	return <BaggageInfo baggageList={baggageList} {...props} />;
};

BaggageInfoContainer.propTypes = {
	baggageList: PropTypes.arrayOf(
		PropTypes.shape({
			type: PropTypes.string.isRequired,
			quantity: PropTypes.number,
			included: PropTypes.bool,
			offered: PropTypes.bool,
			price: PropTypes.number,
			details: PropTypes.oneOfType([PropTypes.string, PropTypes.object]),
		})
	),
};

const mapStateToProps = state => {
	return {
		baggageList: getSelectedBaggageList(state),
	};
};

export default connect(mapStateToProps)(BaggageInfoContainer);
